import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { Button } from "./ui/button";
import { ShieldWarning, ShieldCheck } from "@phosphor-icons/react";

/** Banner in dashboard se il backup automatico non gira da più di 2 giorni (o non è mai stato fatto). */
export default function AvvisoBackup() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = () => api.get("/backup/stato", { cache: false }).then((r) => setS(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  if (!s || s.ok) return null;
  const fai = async () => {
    setBusy(true);
    try { await api.post("/backup"); toast.success("Backup creato"); load(); } catch (e) { toast.error(e.response?.data?.detail || "Backup non riuscito"); } finally { setBusy(false); }
  };
  const testo = s.giorni == null ? "Nessun backup dei dati è mai stato eseguito." : `L'ultimo backup risale a ${Math.floor(s.giorni)} giorni fa: il backup automatico giornaliero non sta girando.`;
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-md border border-red-200 bg-red-50 px-4 py-3 dark:bg-red-950/30 dark:border-red-900" data-testid="avviso-backup">
      <ShieldWarning size={20} className="text-red-700 shrink-0" />
      <div className="flex-1 min-w-[220px]">
        <div className="text-sm font-semibold text-red-900 dark:text-red-200">Backup mancante</div>
        <div className="text-xs text-red-800/80 dark:text-red-300" data-testid="avviso-backup-testo">{testo} I tuoi dati sono comunque al sicuro nel database.</div>
      </div>
      {s.owner && <Button size="sm" onClick={fai} disabled={busy} data-testid="avviso-backup-crea"><ShieldCheck size={14} /> {busy ? "Creo…" : "Fai backup ora"}</Button>}
      <Button asChild size="sm" variant="outline"><Link to="/backup" data-testid="avviso-backup-link">Apri Backup</Link></Button>
    </div>
  );
}
